export const setAnalysisPlanSettings = items => {
  return {
    type: "SET_ANALYSIS_PLAN_SETTINGS",
    items
  };
};

export const getAnalysesPlanSuggestions = payload => {
  return {
    type: "FETCH_ANALYSES_PLAN_LIST",
    payload
  };
};

export const updateAnalysisPlanSettings = resp => ({
  type: "UPDATE_ANALYSIS_PLAN_SETTINGS",
  payload: resp
});

export const saveAnalysisPlanSettings = resp => ({
  type: "SAVE_ANALYSIS_PLAN_SETTINGS",
  payload: resp
});

export const deleteAnalysisPlanSettings = resp => ({
  type: "DELETE_ANALYSIS_PLAN_SETTINGS",
  payload: resp
});



// WEBPACK FOOTER //
// ./src/actions/actions/analysis-plan.js